import { Common } from './common'
import { Errors } from './errors'
import { Login } from './views/Login'
import { ForgotPassword } from './views/ForgotPassword'
import { CreateAccount } from './views/CreateAccount'
import { OrderBOFilter } from './components/OrderBOFilter'
import { DashboardMenu } from './components/DashboardMenu'
import { Orders } from './components/Orders'
import { Filters } from './components/Filters'
import { Modal } from './components/Modal'
import { Volumes } from './components/Volumes'
import { OrderTableFilter } from './components/OrderTableFilter'
import { ModalItems } from './components/ModalItems'
import { DashboardAvailable } from './components/DashboardAvailable'
import { DashboardDispatch } from './components/DashboardDispatch'
import { PartnerTableFilter } from './components/PartnerTableFilter'
import { sectionsMultiFilter } from './components/sectionsMultiFilter'
import { Admin } from './components/Admin'
import { NewSupplier } from './components/NewSupplier'
import { States } from './states'

export const pt = {
  Common,
  Errors,
  Login,
  ForgotPassword,
  CreateAccount,
  OrderBOFilter,
  DashboardMenu,
  Orders,
  Filters,
  Modal,
  Volumes,
  OrderTableFilter,
  ModalItems,
  DashboardAvailable,
  DashboardDispatch,
  PartnerTableFilter,
  sectionsMultiFilter,
  Admin,
  NewSupplier,
  States
}



// WEBPACK FOOTER //
// ./src/translations/pt/index.js